"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIXPANEL_EVENT = void 0;
var MIXPANEL_EVENT;
(function (MIXPANEL_EVENT) {
    MIXPANEL_EVENT["CHECKOUT_PAGO_TARJETA"] = "checkout_pago_tarjeta";
    MIXPANEL_EVENT["CHECKOUT_PAGO_SPEI"] = "checkout_pago_spei";
    MIXPANEL_EVENT["CHECKOUT_PAGO_EFECTIVO"] = "checkout_pago_efectivo";
    MIXPANEL_EVENT["CHECKOUT_ABANDONO_COMPRA"] = "checkout_abandono_compra";
    MIXPANEL_EVENT["USUARIO_REGISTRO"] = "usuario_registro";
    MIXPANEL_EVENT["USUARIO_ACTUALIZA_CONTRASE\u00D1A"] = "usuario_actualiza_contrase\u00F1a";
    MIXPANEL_EVENT["USUARIO_ACTIVA_CUENTA"] = "usuario_actualiza_contrase\u00F1a";
    MIXPANEL_EVENT["USUARIO_LOGIN"] = "usuario_login";
    MIXPANEL_EVENT["USUARIO_LOGOUT"] = "usuario_logout";
    MIXPANEL_EVENT["USUARIO_ERROR_LOGIN"] = "usuario_error_login";
    MIXPANEL_EVENT["BUSQUEDA"] = "busqueda";
    MIXPANEL_EVENT["CURSO_CLICK_TARJETA"] = "curso_click_tarjeta";
    MIXPANEL_EVENT["CURSO_INSCRIPCION"] = "curso_inscripcion";
    MIXPANEL_EVENT["CURSO_GUARDAR"] = "curso_guardar";
    MIXPANEL_EVENT["CURSO_ACCESO_EXTERNO"] = "curso_acceso_externo ";
    MIXPANEL_EVENT["CURSO_DESCARGA_TEMARIO"] = "curso_descarga_temario";
    MIXPANEL_EVENT["PERFIL_ACTUALIZAR_INTERESES"] = "perfil_actualizar_intereses";
    MIXPANEL_EVENT["PERFIL_ACTUALIZAR_PREFERENCIA"] = "perfil_actualizar_preferencia";
    MIXPANEL_EVENT["COMUNIDAD_FEED_REACCION"] = "comunidad_feed_reaccion";
    MIXPANEL_EVENT["BUSQUEDA_FILTROS"] = "busqueda_filtros";
    MIXPANEL_EVENT["MINUTOS_PLATAFORMA_APP"] = "minutos_plataforma_app";
    MIXPANEL_EVENT["PROPAGANDA"] = "propaganda";
    MIXPANEL_EVENT["USUARIO_TEST_VOCATIONAL_INSCRIPCION"] = "usuario_test_vocational_inscripcion";
    MIXPANEL_EVENT["CTA_REGISTRO"] = "cta-registro";
    MIXPANEL_EVENT["S_SIGNUP"] = "s_signup";
    MIXPANEL_EVENT["S_SIGNUP_CHECKOUT"] = "s_signup_checkout";
    MIXPANEL_EVENT["CREAR_CUENTA"] = "crear_cuenta";
    MIXPANEL_EVENT["S_SIGNUP_CONFIRMATION"] = "s_signup_confirmation";
    MIXPANEL_EVENT["S_SETPASSWORD"] = "s_setpassword";
    MIXPANEL_EVENT["SET_PASSWORD"] = "set_password";
    MIXPANEL_EVENT["S_LOGIN"] = "s_login";
})(MIXPANEL_EVENT = exports.MIXPANEL_EVENT || (exports.MIXPANEL_EVENT = {}));
